import { render, staticRenderFns } from "./VrstaSuorganizatoraForma.vue?vue&type=template&id=0d20fbd9&scoped=true&"
import script from "./VrstaSuorganizatoraForma.vue?vue&type=script&lang=js&"
export * from "./VrstaSuorganizatoraForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20fbd9",
  null
  
)

export default component.exports